import React, { useState, useEffect } from 'react';
import Header from '../../assets/header/Header.js';
import Sidebar from '../../assets/sidebar/sidebar.js';
import { AddPerTemplateDetails, GetPERTemplateDetail } from '../../services/adminServices.js';
import { useModal } from '../modalPopup/modelcontext.js';
import { Modal } from 'react-bootstrap';
import { DownloadUploadedDocument } from '../../services/deploymentrequestServices.js';

const PerformanceEvalutionReport = () => {
    const [perDocumentId, setPerDocumentId] = useState(0);  
    const [templateName, setTemplateName] = useState('');
    const [uploaddocument, setUploaddocument] = useState(null);
    const [perUploadedTemplateName, setPerUploadedTemplateName] = useState('');
    const [perUploadedTemplatePath, setPerUploadedTemplatePath] = useState('');
    const [errors, setErrors] = useState({});
    const { showModal } = useModal();
    const [show, setShow] = useState(false);
    const [btnSaveText, setBtnSaveText] = useState('Submit');
    const [isDocumentDeleted, setIsDocumentDeleted] = useState('');
    const [deletedDocumentName, setDeletedDocumentName] = useState('');

    const fetchPERTemplateDetails = async() => {
        GetPERTemplateDetail().then((response) =>{
            if(response.status === 200){
                setPerDocumentId(response.data.perDocumentId);
                setTemplateName(response.data.templateName);
                setPerUploadedTemplateName(response.data.perUploadedTemplateName);
                setPerUploadedTemplatePath(response.data.perUploadedTemplatePath);
                setBtnSaveText('Update');
            }
        });
    };

    useEffect(() => { 
        fetchPERTemplateDetails();        
    },[]);

    const handleInputChange = (e, setter, field) => {
        if(field === 'uploaddocument'){
            setter(e.target.files[0]);
        }else{
            const { value } = e.target;
            setter(value);
        }       
    };

    const validate = () => {
        const newErrors = {};
        if (!templateName) newErrors.templateName = 'Template Name is required.';
        if (!uploaddocument) newErrors.uploaddocument = 'Document is required.';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const savePerTemplate = async () =>{
        try {
            if (!validate()) {
              return;
            }
            const formData = new FormData();
            formData.append('perDocumentId', perDocumentId);
            formData.append('templateName', templateName);
            formData.append('uploaddocument', uploaddocument);
            if (isDocumentDeleted) {
                formData.append('documentDeleted', true);
                formData.append('deletedDocumentName', deletedDocumentName ?? '');
            }else{
                formData.append('documentDeleted', false);
                formData.append('deletedDocumentName', '');
            } 
            AddPerTemplateDetails(formData).then((res) => {
            if (res.data.success) {
                showModal('success',res.data.message);
                fetchPERTemplateDetails();
            } else {
                showModal('failure',res.data.message);
            }       
            });
        } 
        catch (error) {
            showModal('failure','Adding/Updating PER Template failed, Please try again later.');
        }
    };

    const handleClose = () =>{
        setShow(false);
    } 
    
    const handleConfirmDelete = () => {
        setIsDocumentDeleted(true);
        setDeletedDocumentName(perUploadedTemplateName);
        setPerUploadedTemplatePath('');
        setPerUploadedTemplateName('');              
        handleClose();
    };

    const handleDeleteDocument = () => {
        setShow(true);
    };

    const handleDownloadDocument = async (documentName, documentPath) => {
        if (!documentName || !documentPath) {
            showModal('failure', "Document details are missing.");
            return;
        }
        try {
            const response = await DownloadUploadedDocument(documentName, documentPath);
            if (response.success !== false) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const contentDisposition = response.headers['content-disposition'];
                let fileName = documentName; 
                if (contentDisposition && contentDisposition.indexOf('filename=') !== -1) {
                    fileName = contentDisposition.split('filename=')[1].replace(/"/g, ''); 
                }
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                link.click();
                window.URL.revokeObjectURL(url);
            } else {
                showModal('failure', response.message || "Failed to download the document.");
            }
        } catch (error) {
            showModal('failure', "An unexpected error occurred while downloading the file.");
        }
    };

    return (
        <>
            <Header />
            <div className="d-flex">
                <Sidebar />
                <div className="main bg-light-iom">
                    <div className='dashboard-class'>
                        <div className='cont-wrapper'>
                            <div className="container mt-5">
                                <div className="card mb-3">
                                    <div className="card-header">
                                        <h6>Performance Evaluation Report Template</h6>
                                    </div>
                                    <div className='card-body'>
                                        
                                        <div className='row'>
                                            <div className="form-group mb-3 col-md-6">
                                                <label htmlFor="templateName" className="form-label">Template Name <span style={{color:"red", font:"bold"}}>*</span></label>
                                                <input type="text" className="form-control" id="templateName" placeholder="Template Name" value={templateName} onChange={(e) => handleInputChange(e, setTemplateName, 'templateName')} disabled = {perUploadedTemplateName}/>
                                                {errors.templateName && <p style={{color: 'red'}}>{errors.templateName}</p>}
                                            </div> 
                                            {!perUploadedTemplateName && !perUploadedTemplatePath && (   
                                            <div className="form-group mb-3 col-md-6">
                                                <label htmlFor='uploaddocument' className='form-label'>Upload Document <span style={{ color: "red", font: "bold" }}>*</span></label>
                                                <input type="file" className="form-control" id='uploaddocument' onChange={(e) => handleInputChange(e, setUploaddocument, 'uploaddocument')}/>
                                                {errors.uploaddocument && <p style={{color: 'red'}}>{errors.uploaddocument}</p>}
                                            </div>
                                            )}
                                            {perUploadedTemplateName && perUploadedTemplatePath && (
                                            <div className="form-group col-md-6">
                                                <label htmlFor='uploaddocument' className='form-label'>Uploaded Documents <span style={{ color: "red", font: "bold" }}>*</span></label>
                                                <a style={{textDecoration:'auto', fontWeight:'bold'}} className='form-control'>{perUploadedTemplateName}</a>
                                                <button className='btn btn-sm me-4' style={{float:'right', marginTop: '-35px'}} onClick={() => handleDownloadDocument(perUploadedTemplateName, perUploadedTemplatePath)}><i class="bi bi-download" style={{color:'#0000ff'}}></i></button>
                                                <button className='btn btn-sm' style={{float:'right', marginTop: '-35px'}} onClick={() => handleDeleteDocument('torDocuments')}><i class="bi bi-trash" style={{color:'red'}}></i></button>
                                            </div>  
                                            )} 
                                        </div>                                                             
                                        <div className='row'>
                                            <div className="form-group" style={{textAlign:'right'}}>
                                                <button type="submit" id="btnSave" className="btn btn-primary me-2" onClick={savePerTemplate}>{btnSaveText}</button> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Modal show={show} onHide={handleClose} centered>
                                <Modal.Header>
                                    <Modal.Title className="text-center w-100">Confirm Deletion</Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="modal-body-scrollable">
                                    <p>Are you sure you want to delete this document?</p>
                                </Modal.Body>
                                <Modal.Footer>
                                    <button type='button' className="btn btn-secondary me-2"  onClick={handleClose}>
                                    Cancel
                                    </button>
                                    <button type='button' className="btn btn-danger" onClick={handleConfirmDelete}>
                                        Delete
                                    </button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default PerformanceEvalutionReport;
